import * as React from "react";
import { useLocalStorage } from "@grandvisionhq/lib-utils-w3c";
const CART_STORAGE_KEY = "stored_cart";
const initialState = {
  cartId: null,
  cartHash: null,
  cartCount: 0
};
const useCartStorage = () => {
  const [data, setData, remove] = useLocalStorage(CART_STORAGE_KEY, initialState);
  React.useDebugValue(data);
  const setCartId = React.useCallback(
    (cartId) => {
      setData((data2) => {
        return { ...data2, cartId };
      });
    },
    [setData]
  );
  const setCartHash = React.useCallback(
    (cartHash) => {
      setData((data2) => {
        return { ...data2, cartHash };
      });
    },
    [setData]
  );
  const setCartCount = React.useCallback(
    (newCount) => {
      setData((data2) => {
        if (data2.cartCount === newCount) {
          return data2;
        }
        return { ...data2, cartCount: newCount };
      });
    },
    [setData]
  );
  const reset = () => {
    remove();
  };
  return [data, { setCartId, setCartHash, setCartCount, reset, setData }];
};
export {
  CART_STORAGE_KEY,
  useCartStorage
};
//# sourceMappingURL=use-cart-storage.js.map
